import { defineStore } from 'pinia'

export const useSystemStore = defineStore('system', {
  state: () => ({
    maintenance: {
      active: false,
      status: null,
      message: null,
    },
    lastRoute: null,
  }),
  actions: {
    setLastRoute(route) {
      this.lastRoute = route
    },
    setMaintenance({ status, message }) {
      this.maintenance = {
        active: true,
        status,
        message,
      }
    },
    clearMaintenance() {
      this.maintenance = {
        active: false,
        status: null,
        message: null,
      }
      this.lastRoute = null
    },
  },
})
